import { render } from "./BasicBox.vue?vue&type=template&id=e55f4958"
import script from "./BasicBox.vue?vue&type=script&lang=js"
export * from "./BasicBox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BasicBox.vue?vue&type=style&index=0&id=e55f4958&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__